import React from 'react';
import { FormikProps } from 'formik';
import { FormikTextInput } from 'src/common/form/formik/text-input';
import { JourneyFormik, JourneyForm } from 'src/common/JourneyFormik';
import { ToggleButton } from '../../components/dashboard/create-journey-modal';
// import { getValidationSchema } from '../element-config-form.factory';
import { NativeFormDropdownInput, NativeFormElement } from '../store';
import { AutoSubmitForm } from '../auto-submit-form';
import { NativeFormConfigInputOptions } from './input-options';
import { FormikTextarea } from 'src/common/form/formik/textarea';

type NativeFormDropdownFormProps<T extends NativeFormElement> = {
  onSubmit: (values: Partial<T>) => void;
} & T;

export const NativeFormConfigDropdownForm = <T extends NativeFormElement>({
  onSubmit,
  ...props
}: NativeFormDropdownFormProps<T>) => {
  const formProps = props as unknown as NativeFormDropdownInput;
  const formikParams = {
    initialValues: props,
    // validationSchema: getValidationSchema('dropdown', props.required),
    onSubmit,
    validateOnChange: true,
  };

  return (
    <JourneyFormik {...formikParams}>
      {({ setFieldValue }: FormikProps<Record<string, string | boolean>>) => (
        <JourneyForm className='flex flex-col gap-4 shrink-0'>
          <AutoSubmitForm />
          <FormikTextInput
            isNeue
            id='label'
            name='label'
            required
            type='text'
            inputClasses='h-9 w-full'
            label='Label'
            labelClassName='text-neue-journey-fg text-neue-journey-medium-strong'
          />
          <FormikTextarea
            id='description'
            name='description'
            inputClasses='h-24 w-full bg-neue-journey-bg-90 !text-neue-journey-fg'
            label='Description'
            labelClassName='block text-neue-journey-medium-strong text-neue-journey-fg'
            hideOptional
          />
          <div className='flex flex-col gap-2'>
            <span className='text-neue-journey-medium-strong'>Required</span>
            <div className='flex gap-2'>
              <ToggleButton
                selected={props.required}
                label={<span>Yes</span>}
                onClick={() => {
                  setFieldValue('required', true);
                }}
              />
              <ToggleButton
                selected={!props.required}
                label={<span>No</span>}
                onClick={() => {
                  setFieldValue('required', false);
                }}
              />
            </div>
          </div>
          <NativeFormConfigInputOptions
            options={formProps.options}
            onAdd={() => {
              setFieldValue('options', [
                ...formProps.options,
                {
                  label: `Option ${formProps.options.length + 1}`,
                  value: `option_${formProps.options.length + 1}`,
                },
              ]);
            }}
            onRemove={(index) => {
              setFieldValue(
                'options',
                formProps.options.filter((_, i) => i !== index)
              );
            }}
          />
        </JourneyForm>
      )}
    </JourneyFormik>
  );
};
